const lang = getLang();
function getLang() {
  let language;
  if(window.sessionStorage.getItem("online_exam_language") === undefined
    || window.sessionStorage.getItem("online_exam_language") === null
    || window.sessionStorage.getItem("online_exam_language") === "") {
      if(window.localStorage.getItem("online_exam_language") === undefined
      || window.localStorage.getItem("online_exam_language") === null
      || window.localStorage.getItem("online_exam_language") === "") {
        language = 'vi';
    }else{
      language = window.localStorage.getItem("online_exam_language");
    }
  } else {
    language = window.sessionStorage.getItem("online_exam_language");
  }
  if ("zh" === language
    || "zh-tw" === language
    || "zh-hk" === language
    || "zh_CN" === language
    || "zh-CN" === language) {
    return "zh"
  }
  if ("en" === language
    || "en-US" === language
    || "en-au" === language
    || "en-nz" === language
    || "en-tt" === language
    || "en-za" === language
    || "nl-be" === language) {
    return "en"
  }
  if ("ja" === language
    || "ja_JP" === language
    || "ja-JP" === language) {
    return "ja"
  }
  if ("vi" === language
    || "vi-VN" === language
    || "ve" === language) {
    return "vi"
  }
  return "vi"
}
export default lang





// WEBPACK FOOTER //
// ./src/assets/languages/getLang.js